import React from "react";
import Header from "../header/AppHeader";
import ProfileCard from "../profile/ProfileCard";
import background from "../../assets/dashboard-bg.jpg";

const COORDINATOR = {
  program: "Spirit 2026 · IIT Guwahati CA Program",
  team: "Spirit Program Team",
  email: "spirit.ca2026@gmail.com",
  hours: "Mon–Fri · 10:00 AM – 6:00 PM IST",
};

const Contact = () => {
  return (
    <div
      className="min-h-[100dvh] w-full overflow-x-hidden lg:h-screen lg:w-screen lg:overflow-hidden bg-center bg-cover bg-no-repeat text-[#2B1B17] font-['Montserrat',sans-serif] antialiased flex flex-col"
      style={{ backgroundImage: `url(${background})` }}
    >
      <Header activeTab="Contact" />

      {/* --- HERO SECTION --- */}
      <section className="px-6 md:px-12 pt-6 pb-5 max-w-[1600px] mx-auto w-full flex-shrink-0">
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-end gap-8 relative z-10">

          <div className="text-white flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-5 max-w-3xl">
            <h1 className="text-5xl md:text-6xl font-black tracking-tight drop-shadow-sm font-['Barlow',sans-serif]">
              Contact
            </h1>
            <p className="text-sm md:text-base text-white/90 leading-relaxed font-normal drop-shadow-sm sm:max-w-[40rem]">
              Stuck on a task, a submission, or your registration? Reach the coordinator team directly below.
            </p>
          </div>

          {/* PROFILE CARD */}
          <ProfileCard />

        </div>
      </section>

      {/* --- MAIN GRID --- */}
      <main className="max-w-[1600px] mx-auto px-2 md:px-2 w-full relative z-20 overflow-y-auto lg:flex-1 lg:min-h-0 pb-2">
        <div className="grid grid-cols-1 gap-5 items-stretch lg:h-full">

          {/* FULL WIDTH: COORDINATOR DETAILS */}
          <div className="bg-[#F5EFEB]/90 backdrop-blur-md rounded-2xl p-6 md:p-7 shadow-xl border border-white/20 lg:overflow-y-auto lg:min-h-0 w-full">
            <div className="mb-5 pb-4 border-b border-black/5">
              <h2 className="text-sm font-black tracking-widest text-[#2B1B17]/60 uppercase font-['Barlow',sans-serif]">Coordinator Details</h2>
              <p className="text-xs text-black/40 font-medium mt-0.5">{COORDINATOR.program}</p>
            </div>
            
            <div className="flex flex-col gap-5">
              {/* Coordinator Team */}
              <div>
                <p className="text-[11px] font-bold tracking-widest text-[#2B1B17]/40 uppercase font-['Barlow',sans-serif]">Coordinator</p>
                <p className="font-bold text-[#2B1B17] mt-1 font-['Barlow',sans-serif]">{COORDINATOR.team}</p>
              </div>

              {/* Clickable Email */}
              <div>
                <p className="text-[11px] font-bold tracking-widest text-[#2B1B17]/40 uppercase font-['Barlow',sans-serif]">Email</p>
                <p className="mt-1">
                  <a 
                    href={`mailto:${COORDINATOR.email}`} 
                    className="font-bold text-[#000] hover:opacity-80 transition-opacity"
                  >
                    {COORDINATOR.email}
                  </a>
                </p>
              </div>

              {/* Office Hours */}
              <div>
                <p className="text-[11px] font-bold tracking-widest text-[#2B1B17]/40 uppercase font-['Barlow',sans-serif]">Office Hours</p>
                <p className="font-bold text-[#2B1B17] mt-1">{COORDINATOR.hours}</p>
              </div>

              {/* Social Channels */}
              <div className="pt-4 border-t border-black/5">
                <p className="text-[11px] font-bold tracking-widest text-[#2B1B17]/40 uppercase mb-2 font-['Barlow',sans-serif]">Social</p>
                <div className="flex flex-wrap gap-x-3 gap-y-1 text-sm font-bold text-[#D15B28]">
                  <a href="https://www.instagram.com/spirit_iitguwahati/" target="_blank" rel="noreferrer" className="hover:opacity-80">Instagram</a>
                  <span className="text-black/20">·</span>
                  <a href="https://www.linkedin.com/company/spiritiitguwahati/" target="_blank" rel="noreferrer" className="hover:opacity-80">LinkedIn</a>
                </div>
              </div>
            </div>
          </div>

        </div>
      </main>
    </div>
  );
};

export default Contact;